module.exports = __webpack_public_path__ + "img/avatar6.96717007.png";